require("!!/Users/admin/Projects/material-dashboard-angular-master/node_modules/script-loader/addScript.js")(require("!!/Users/admin/Projects/material-dashboard-angular-master/node_modules/raw-loader/index.js!/Users/admin/Projects/material-dashboard-angular-master/node_modules/source-map-loader/index.js!/Users/admin/Projects/material-dashboard-angular-master/src/assets/js/material.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/assets/js/material.min.js
// module id = 268
// module chunks = 2